import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  getTiposDeVehiculos,
  postTipoDeVehiculo,
  patchTipoDeVehiculo,
  deleteTipoDeVehiculo,
} from 'api/recaudacion/tiposDeVehiculos';

// eslint-disable-next-line react/prop-types
const TiposDeDeVehiculos = ({ permission }) => (
  <PlainCRUD
    title="Tipo de vehículo"
    get={getTiposDeVehiculos}
    post={postTipoDeVehiculo}
    patch={patchTipoDeVehiculo}
    delete={deleteTipoDeVehiculo}
    fields={[defaultFields.nombre]}
    permission={permission}
  />
);

export default TiposDeDeVehiculos;
